import axios from "axios";
import { quillEditor } from "vue-quill-editor";

document.addEventListener("DOMContentLoaded", function () {
	if (document.getElementById("eligbility_form")) {
		startEligibilityForm();
	}
	if (document.getElementById("blog_posting_custom_form")) {
		startBlogPostingForm();
	}
});

const startEligibilityForm = () => {
	var app = new Vue({
		el: "#eligbility_form",
		data: {
			message: "Hello Vue!",
			user: {},
			sgos: {},
			sgo: {
				organization_name_in_english: "",
				["english-language_website_url"]: "",
				motto_or_slogan: "",
				year_of_registration: "",
				country_of_registration: "",
				country_of_lead_office: "",
			},
			acceptance: true,
			ready: false,
			createnew: false,
			is_submitting: false,
		},
		methods: {
			handleSubmit(e) {
				this.is_submitting = true;
				if (this.createnew) {
					let form_data = new FormData();
					form_data.append("action", "create_new_sgo");
					form_data.append("organization_name_in_english", this.sgo.organization_name_in_english);
					form_data.append("english-language_website_url", this.sgo["english-language_website_url"]);
					form_data.append("motto_or_slogan", this.sgo.motto_or_slogan);
					form_data.append("year_of_registration", this.sgo.year_of_registration);
					form_data.append("country_of_registration", this.sgo.country_of_registration);
					form_data.append("country_of_lead_office", this.sgo.country_of_lead_office);
					axios.post(ajaxurl, form_data)
						.then((res) => {
							if (res.data) {
								this.user.sgos_requested_to_managent;
								let form_data2 = new FormData();
								form_data2.append("action", "send_email_pending_review");
								axios.post(ajaxurl, form_data2)
									.then((res) => {
										this.is_submitting = false;
										setTimeout(() => {
											window.location.reload();
										}, 2000);
									})
									.catch((err) => {
										alert(err);
										this.is_submitting = false;
									});
							}
						})
						.catch((err) => {
							alert(err);
						});
				} else {
					let form_data = new FormData();
					form_data.append("action", "send_email_pending_review");
					axios.post(ajaxurl, form_data)
						.then((res) => {
							setTimeout(() => {
								window.location.reload();
								this.is_submitting = false;
							}, 2000);
						})
						.catch((err) => {
							alert(err);
							this.is_submitting = false;
						});
				}
			},
			updateBooleanManuel(event, el, val) {
				this.user[el] = val;
				this.updateForm(event, el, "boolean");
			},
			updateForm(e, field, type) {
				e.target.parentNode.classList.add("loading");
				if (type === "text") {
					let form_data = new FormData();
					form_data.append("action", "update_user_eligibility");
					form_data.append("field", field);
					form_data.append("newval", this.user[field]);
					axios.post(ajaxurl, form_data)
						.then((res) => {
							e.target.parentNode.classList.remove("loading");
							e.target.parentNode.classList.add("saved");
							setTimeout(() => {
								e.target.parentNode.classList.remove("saved");
							}, 3000);
						})
						.catch((err) => {
							e.target.parentNode.classList.remove("loading");
							e.target.parentNode.classList.add("error");
							setTimeout(() => {
								e.target.parentNode.classList.remove("error");
							}, 3000);
						});
				} else if (type === "boolean") {
					let form_data = new FormData();
					form_data.append("action", "update_user_eligibility_boolean");
					form_data.append("field", field);
					form_data.append("newval", e.target.value);
					axios.post(ajaxurl, form_data)
						.then((res) => {
							e.target.parentNode.classList.remove("loading");
							e.target.parentNode.classList.add("saved");
							setTimeout(() => {
								e.target.parentNode.classList.remove("saved");
							}, 3000);
						})
						.catch((err) => {
							e.target.parentNode.classList.remove("loading");
							e.target.parentNode.classList.add("error");
							setTimeout(() => {
								e.target.parentNode.classList.remove("error");
							}, 3000);
						});
				} else if (type === "array") {
					let form_data = new FormData();
					form_data.append("action", "update_user_eligibility");
					form_data.append("field", field);
					form_data.append("newval", [this.user[field]]);
					axios.post(ajaxurl, form_data)
						.then((res) => {
							e.target.parentNode.classList.remove("loading");
							e.target.parentNode.classList.add("saved");
							setTimeout(() => {
								e.target.parentNode.classList.remove("saved");
							}, 3000);
						})
						.catch((err) => {
							e.target.parentNode.classList.remove("loading");
							e.target.parentNode.classList.add("error");
							setTimeout(() => {
								e.target.parentNode.classList.remove("error");
							}, 3000);
						});
				}
			},
			getSGO() {
				let form_data = new FormData();
				form_data.append("action", "get_list_of_sgo");
				axios.post(ajaxurl, form_data)
					.then((res) => {
						this.sgos = res.data.sgos;
					})
					.catch((err) => {
						console.log(err);
					});
			},
			getUser() {
				let form_data = new FormData();
				form_data.append("action", "get_current_user_eligibility");
				axios.post(ajaxurl, form_data)
					.then((res) => {
						this.user = res.data.user;
						this.ready = true;
					})
					.catch((err) => {
						console.log(err);
					});
			},
		},
		mounted() {
			this.getUser();
			this.getSGO();
		},
	});
};

const startBlogPostingForm = () => {
	var app = new Vue({
		el: "#blog_posting_custom_form",
		components: {
			quillEditor,
		},
		data: {
			message: "Hello",
			ready: false,
			post: {},
			id: 0,
			editorOption: {
				theme: "snow",
				modules: {
					toolbar: [
						["bold", "italic", "underline", "strike"],
						[{ list: "ordered" }, { list: "bullet" }],
						[{ script: "sub" }, { script: "super" }],
						[{ indent: "-1" }, { indent: "+1" }],
						["clean"],
					],
				},
			},
		},
		methods: {
			uploadFeatured(e) {
				e.target.parentNode.classList.add("loading");
				let form_data = new FormData();
				form_data.append("action", "update_post_featured");
				form_data.append("id", this.id);
				form_data.append("file", e.target.files[0]);
				axios.post(ajaxurl, form_data)
					.then((res) => {
						e.target.parentNode.classList.remove("loading");
						this.post.featured = res.data.lien;
					})
					.catch((err) => {
						e.target.parentNode.classList.remove("loading");
						console.log(err);
					});
			},
			updateImage(e, field) {
				e.target.parentNode.classList.add("loading");
				let form_data = new FormData();
				form_data.append("action", "update_post_image");
				form_data.append("id", this.id);
				form_data.append("field", field);
				form_data.append("file", e.target.files[0]);
				axios.post(ajaxurl, form_data)
					.then((res) => {
						e.target.parentNode.classList.remove("loading");
						this.post.fields[field] = res.data.lien;
					})
					.catch((err) => {
						e.target.parentNode.classList.remove("loading");
						console.log(err);
					});
			},
			save_and_publish(e) {
				this.post.post_status = "publish";
				this.updatePost(e, "post_status", "global");
			},
			updatePost(e, field, type) {
				if (type === "boolean") {
					console.log(this.post.fields[field]);
					let form_data = new FormData();
					form_data.append("action", "update_post_field_boolean");
					form_data.append("id", this.id);
					form_data.append("field", field);
					form_data.append("newval", this.post.fields[field]);
					axios.post(ajaxurl, form_data).finally(() => {
						console.log("ok");
					});
				} else if (type === "global") {
					let form_data = new FormData();
					form_data.append("action", "update_post_global");
					form_data.append("id", this.id);
					form_data.append("title", this.post.post_title);
					form_data.append("content", this.post.content);
					form_data.append("status", this.post.post_status);
					form_data.append("skin", this.post.skin);
					form_data.append("author", this.post.fields.this_post_is_published_for_an_sgo);
					axios.post(ajaxurl, form_data).finally(() => {
						console.log("ok");
					});
				} else if (type === "text") {
					let form_data = new FormData();
					form_data.append("action", "update_post_field");
					form_data.append("id", this.id);
					form_data.append("field", field);
					form_data.append("newval", this.post.fields[field]);
					axios.post(ajaxurl, form_data).finally(() => {
						console.log("ok");
					});
				} else if (type === "array") {
					let form_data = new FormData();
					form_data.append("action", "update_post_field");
					form_data.append("id", this.id);
					form_data.append("field", field);
					form_data.append("newval", [this.post.fields[field]]);
					axios.post(ajaxurl, form_data).finally(() => {
						console.log("ok");
					});
				}
			},
			getPost() {
				let post_id = this.$refs.theform.dataset.postid;
				this.id = post_id;
				let form_data = new FormData();
				form_data.append("action", "get_blogpost");
				form_data.append("id", post_id);
				axios.post(ajaxurl, form_data)
					.then((res) => {
						this.post = res.data.post;
						this.ready = true;
					})
					.catch((err) => {
						alert(err);
					});
			},
			handleSubmit(e) {
				//window.location.reload();
				console.log(this.post);
			},
		},
		mounted() {
			this.getPost();
		},
	});
};
